import * as React from 'react';

import {formEncodedApi} from 'nutshell-core/api';

import {SlideshowContainer} from 'shells/carousel/slideshow-container';

import {SlideOne, SlideTwo} from './onboarding-slides';

type Props = {
    onModalClose: () => void;
    cancelButtonText: string;
};

export class OnboardingPhone extends React.PureComponent<Props> {
    static defaultProps = {
        cancelButtonText: 'Skip this',
    };

    constructor(props: Props) {
        super(props);
        Analytics.trackEvent(
            Analytics.categories.views,
            Analytics.actions.views.showOnboardingPhoneModal
        );
    }

    render() {
        const slides = [
            <SlideOne key={1} cancelButtonText={this.props.cancelButtonText} />,
            <SlideTwo
                key={2}
                onSetupPhone={(e) => this.goToPhoneSettings(e)}
                cancelButtonText={this.props.cancelButtonText}
            />,
        ];

        return (
            <div className='onboarding-phone-slideshow-wrapper'>
                <SlideshowContainer showControls={false} onDismiss={() => this.dismissModal()}>
                    {slides}
                </SlideshowContainer>
            </div>
        );
    }

    goToPhoneSettings(e: React.SyntheticEvent<any>) {
        e.preventDefault();
        const phoneSettingsURL = e.currentTarget.getAttribute('href');
        if (location.pathname === phoneSettingsURL) {
            this.dismissModal();

            return;
        }

        formEncodedApi
            .post('/my-account/save-user-setting.json', {
                setting: 'hide_onboarding_phone',
                value: 1,
            })
            .then(function () {
                window.location = phoneSettingsURL;
            });
    }

    dismissModal() {
        formEncodedApi
            .post('/my-account/save-user-setting.json', {
                setting: 'hide_onboarding_phone',
                value: 1,
            })
            .then(() => {
                if (this.props.onModalClose) this.props.onModalClose();
            });
    }
}
